const en = {
	staff: 'staff',
	staffDisabled: 'disabled staff',
	name: 'name',
	phone: 'mobile',
	email: 'email',
	status: 'status',
	active: 'enable',
	addStaff: 'add staff',
	staffList: 'staffs',
	staffAdmin: 'staff administration',
};

export default en;
